import { EMAIL_VALIDATOR_PATTERN } from '@core/constants/FomPatterns';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import {
  Component,
  EventEmitter,
  Output,
  OnInit,
  OnDestroy,
  Input,
  AfterViewInit
} from '@angular/core';
import { REMEMBER, REGISTER } from '@core/constants/RoutingsPath';
import { fromEvent, Observable, Subject } from 'rxjs';
import { first, takeUntil } from 'rxjs/operators';
import { LoginError } from '@modules/public/login/login-error.type';

@Component({
    selector: 'app-login-form',
    templateUrl: './login-form.component.html',
    styleUrls: ['./login-form.component.scss'],
    standalone: false
})
export class LoginFormComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() loginError!: Observable<LoginError>;

  @Output() submitForm: EventEmitter<any> = new EventEmitter<any>();
  @Output() completeVerification: EventEmitter<string> = new EventEmitter<string>();

  form: any = this.initForm();
  isSubmited = false;
  errorFeedbackList = this.loadFeedbackErrorLists();
  rememberPath = `/${REMEMBER}`;
  registerPath = `/${REGISTER}`;

  screenSize: string = '';
  destroy$: Subject<void> = new Subject();

  isNotVerifiedEmail = false;

  get isShowSubmitButton(): boolean {
    return !this.isNotVerifiedEmail;
  }

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    this.errorFeedbackList = this.loadFeedbackErrorLists();
    this.loginError.subscribe((loginError: LoginError) => {
      if (loginError.type === 'NOT_ACTIVATE') {
        this.isNotVerifiedEmail = true;
        return;
      }

      if (loginError.type === 'INCORRECT') {
        (this.form as UntypedFormGroup).get('email')?.setErrors({ incorrect: true });
        return;
      }

      (this.form as UntypedFormGroup).get('email')?.setErrors(null);
    });

    fromEvent(window, 'resize')
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.screenSize = this.getScreenSize();
      });

    this.screenSize = this.getScreenSize();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  ngAfterViewInit(): void {
    (this.form as UntypedFormGroup).valueChanges.subscribe((value: string) => {
      (this.form as UntypedFormGroup).get('email')?.setErrors(null);
    });
  }

  onSubmit() {
    this.isSubmited = true;
    if (this.form && this.form.valid) {
      this.submitForm.emit(this.form.value);
    }
  }

  onCompleteVerification() {
    this.completeVerification.emit(this.form.get('email').value);
  }

  private initForm(): UntypedFormGroup {
    return this.fb.group({
      email: ['', [Validators.required, Validators.pattern(EMAIL_VALIDATOR_PATTERN)]],
      password: ['', [Validators.required]]
    });
  }

  private loadFeedbackErrorLists() {
    return {
      email: {
        required: 'form.errors.required',
        pattern: 'form.errors.emailLoginPattern',
        incorrect: 'form.errors.incorrect'
      },
      password: {
        required: 'form.errors.required'
      }
    };
  }

  getScreenSize() {
    const width = window.innerWidth;

    if (width >= 960) {
      return 'Desktop';
    } else {
      return 'Mobile';
    }
  }
}
